var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import emblaCarouselVue from "../../../node_modules/.pnpm/embla-carousel-vue@8.6.0_vue@3.5.16_typescript@5.8.3_/node_modules/embla-carousel-vue/esm/embla-carousel-vue.esm.js";
import { ref, onMounted } from "vue";
import { createInjectionState } from "../../../node_modules/.pnpm/@vueuse_shared@13.3.0_vue@3.5.16_typescript@5.8.3_/node_modules/@vueuse/shared/index.js";
const [useProvideCarousel, useInjectCarousel] = createInjectionState(
  ({
    opts,
    orientation,
    plugins
  }, emits) => {
    const [emblaNode, emblaApi] = emblaCarouselVue({
      ...opts,
      axis: orientation === "horizontal" ? "x" : "y"
    }, plugins);
    function scrollPrev() {
      var _a;
      (_a = emblaApi.value) == null || _a.scrollPrev();
    }
    __name(scrollPrev, "scrollPrev");
    function scrollNext() {
      var _a;
      (_a = emblaApi.value) == null || _a.scrollNext();
    }
    __name(scrollNext, "scrollNext");
    const canScrollNext = ref(!1), canScrollPrev = ref(!1);
    function onSelect(api) {
      canScrollNext.value = (api == null ? void 0 : api.canScrollNext()) || !1, canScrollPrev.value = (api == null ? void 0 : api.canScrollPrev()) || !1;
    }
    return __name(onSelect, "onSelect"), onMounted(() => {
      var _a, _b, _c;
      emblaApi.value && ((_a = emblaApi.value) == null || _a.on("init", onSelect), (_b = emblaApi.value) == null || _b.on("reInit", onSelect), (_c = emblaApi.value) == null || _c.on("select", onSelect), emits("init-api", emblaApi.value));
    }), { carouselRef: emblaNode, carouselApi: emblaApi, canScrollPrev, canScrollNext, scrollPrev, scrollNext, orientation };
  }
);
function useCarousel() {
  const carouselState = useInjectCarousel();
  if (!carouselState)
    throw new Error("useCarousel must be used within a <Carousel />");
  return carouselState;
}
__name(useCarousel, "useCarousel");
export {
  useCarousel,
  useProvideCarousel
};
//# sourceMappingURL=useCarousel.js.map
